import { cn } from '#/lib/utils';

import { StatsSection } from './StatsSection';

const responsibleAIStats = [
  {
    stat: '1150%',
    caption: 'growth in responsible AI workflows',
    content:
      'Workflows powering responsible AI surged 12× this year, as global companies raced to build the data infrastructure needed to manage user information for AI.',
    contentClassName: 'text-18 ml:',
    captionClassName: 'text-electric-05',
  },
];

const responsibleAIStatsClassNames = {
  container: cn('bg-cipher-05'),
  stat: cn('text-cipher-08'),
  caption: cn('ml:text-[24px]'),
};

export const ResponsibleAI = () => {
  return (
    <StatsSection
      className="bg-cipher-08 text-cloud"
      stats={responsibleAIStats}
      statsClassNames={responsibleAIStatsClassNames}
      statsHeading={
        <>
          Powering <span className="text-electric-05">responsible AI </span>
        </>
      }
      statsIntro="In 2025, Transcend helped customers clearly permission their consumer data, enabling current and future AI deployments grounded in responsibility and trust."
    />
  );
};
